import { cn } from "@/libs/utils";
import { TabMenu, TabVariants } from "@/types/Shared/tab";
import { useLocation, useNavigate } from "react-router-dom";
import CommonImg from "@/components/Common/Img";

type Props = {
  variants: TabVariants;
  data: TabMenu[];
  state?: any;
};
export default function CommonTab({
  variants = "string",
  data,
  state = {},
}: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/");
  const getCurrent = (tab: TabMenu) => {
    return location.pathname === tab.path;
  };

  const handleClick = (tab: TabMenu) => {
    if (tab.isLink) {
      window.open(tab.path);
    } else {
      navigate(`${tab.path}`, { state: { ...state } });
    }
  };
  return (
    <div className="flex gap-[10px]">
      {data.map((tab: TabMenu, index: number) => {
        switch (variants) {
          case "button":
            return (
              <div
                key={index}
                className={cn(
                  "px-3 py-[6px] bg-gray-D rounded flex gap-[8px] items-center text-gray-B text-sm font-semibold cursor-pointer hover:bg-gray-C",
                  {
                    "bg-dark-red text-white hover:bg-dark-red-hover":
                      getCurrent(tab),
                  }
                )}
                onClick={() => {
                  handleClick(tab);
                }}
              >
                {tab.icon && getCurrent(tab) ? (
                  <CommonImg src={tab.activeIcon} alt={""} />
                ) : (
                  <CommonImg src={tab.icon} alt={""} />
                )}
                {tab.label}
              </div>
            );
          case "string":
          default:
            return (
              <div
                key={index}
                className={cn("cursor-pointer text-gray-B font-bold text-lg", {
                  "text-dark-red border-b-4 border-dark-red": getCurrent(tab),
                })}
                onClick={() => {
                  handleClick(tab);
                }}
              >
                {tab.label}
              </div>
            );
        }
      })}
    </div>
  );
}
